import keyMirror from 'keymirror';

export default keyMirror({
  SCROLL_WIDGET: null
});
